import React, { useState }  from 'react'
import { Col, Flex, Row, Space, Table, Input, Button } from 'antd'
import ZCard from '../../Card/Index'
import { useSelector } from "react-redux";
import { SearchOutlined } from '@ant-design/icons';
import styles from "./counterparty.module.scss";
import { CURRENCY } from '../../../utils/ConstantData';
import { TabsEnum } from '../../../utils/Enum/ReportTabsEnum';
import CustomAmountText from '../../common/CustomAmountText';

const CounterpartyPage = ({onClickTabChange = () => { }}) => {
    const {
        counterpartyDetails: counterpartyData,
      } = useSelector(({ counterparty }) => counterparty);
      console.log("categoriesData", counterpartyData);
    return(
        <TransactionsTable onClickTabChange={onClickTabChange} transactionData={counterpartyData} />
    )
}

const TransactionsTable = ({ transactionData, onClickTabChange = () => { }, tableProps, ...restProps }) => {
    
    const [creditSearch, setCreditSearch] = useState('');
    const [debitSearch, setDebitSearch] = useState('');

    const [creditPagination, setCreditPagination] = useState({
        current: 1,
        pageSize: 5, 
    });
    const [debitPagination, setDebitPagination] = useState({
        current: 1,
        pageSize: 5, 
    });

    const handleCreditTableChange = (pagination) => {
        setCreditPagination(pagination);
      };
    
    // Handle pagination changes for Debit
    const handleDebitTableChange = (pagination) => {
        setDebitPagination(pagination);
    };

    const handleCreditSearch = (e) => {
        setCreditSearch(e.target.value);
    };
    
    const handleDebitSearch = (e) => {
    setDebitSearch(e.target.value);
    };

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2 }).format(amount);
    };

  const creditColumns = [
    {
      title: 'Counterparty',
      dataIndex: 'counterparty',
      key: 'counterparty',
      className: styles.colStyle,
    },
    {
      title: `Amount (${CURRENCY})`,
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      className: 'no-wrap-column',
    //   className: styles.colStyle,
      render: (text) => <CustomAmountText value={text} />,
    },
    {
        title: 'Amount %',
        dataIndex: 'transactionPercentage',
        key: 'transactionPercentage',
        className: styles.colStyle,
        render: (text) => `${text}%`,

    },
    {
      title: 'Transaction Count',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      render: (value, record, index) => {
        return (parseFloat(value) > 0 && transactionData.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
      },
      className: styles.colStyle,
    },

  ];

  const debitColumns = [...creditColumns];
  const filteredCreditData = transactionData?.credit?.filter((item) =>
    item.counterparty.toLowerCase().includes(creditSearch.toLowerCase())
  ) || [];

  const filteredDebitData = transactionData?.debit?.filter((item) =>
    item.counterparty.toLowerCase().includes(debitSearch.toLowerCase())
  ) || [];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
        <Col xs={24} sm={24} md={12}>
            <ZCard>
                <Flex className='pl-16 ' justify='space-between'>
                    <ZCard.Title>{`Credit Transaction (${filteredCreditData.length})`}</ZCard.Title>
                    <Space direction="vertical">
                        <Input
                        placeholder="Search Credit Counterparty"
                        value={creditSearch}
                        style={{ width: 300 }}
                        onChange={handleCreditSearch}
                        suffix={<SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }}/>}
                        />
                    </Space>
                </Flex>
                <Table
                    columns={creditColumns}
                    dataSource={filteredCreditData}
                    rowKey="counterparty"
                    pagination={{
                        current: creditPagination.current,
                        pageSize: creditPagination.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ['5', '10', '20', '50'],
                        total: filteredCreditData.length,
                    }}
                    onChange={handleCreditTableChange} 
                />
            </ZCard>
        </Col>
        <Col xs={24} sm={24} md={12}>
            <ZCard>
                <Flex className='pl-16 ' justify='space-between'>
                    <ZCard.Title>{`Debit Transaction (${filteredDebitData.length})`}</ZCard.Title>
                    <Space direction="vertical">
                        <Input
                        placeholder="Search Debit Counterparty"
                        value={debitSearch}
                        style={{ width: 300 }}
                        onChange={handleDebitSearch}
                        suffix={<SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }}/>}
                        />
                    </Space>
                </Flex>
                <Table
                    columns={debitColumns}
                    dataSource={filteredDebitData}
                    rowKey="counterparty"
                    pagination={{
                        current: debitPagination.current,
                        pageSize: debitPagination.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ['5', '10', '20', '50'],
                        total: filteredDebitData.length,
                    }}
                    onChange={handleDebitTableChange}
                />
            </ZCard>
        </Col>
    </Row>
  )
}

export default CounterpartyPage